import React, {useEffect} from "react";
import {any, func} from "prop-types";
import {CustomButton} from "@hapinest/theme";
import { useI18N } from "../../../common/common";
import {useNimbus} from "../../../hooks/useNimbus";
import { withSnackbar } from "../../hoc/SnackbarHOC";

const NimbusConnectButton = ({children, showSnackbar, ...props}) => {
    const {i18n} = useI18N();
    const {login, loginRedirectUri, loadingLogin, errorLogin} = useNimbus();

    const handleClick = () => {
        login();
    };

    useEffect(() => {
        if (loginRedirectUri) {
            if(props?.openInNewTab) {
                window.open(loginRedirectUri, "_blank", "noopener, noreferrer");
            } else {
                location.assign(loginRedirectUri);
            }
        }
    }, [loginRedirectUri]);

    useEffect(() => {
        if (errorLogin) {
            showSnackbar({
                type: errorLogin.status === 404 ? "info" : "warning",
                message: errorLogin.status === 404 ? i18n("common.label.cannot_vote") : i18n("common.label.generic_error"),
                withIcon: true,
                vertical: props?.snackbarVertical || "bottom",
                animationDirection: props?.snackbarDirection || "up",
            });
        }
    }, [errorLogin]);

    return (
        <CustomButton
            {...props}
            onClick={handleClick}
            loading={loadingLogin}
        >
            {children}
        </CustomButton>
    );
};

NimbusConnectButton.propTypes = {
    children: any,
    showSnackbar: func,
    props: any
};

export default withSnackbar(NimbusConnectButton);
